/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetCompositionsDetailByIdQueryResponse, WebAppGetCompositionsDetailByIdPathParams, WebAppGetCompositionsDetailById401, WebAppGetCompositionsDetailById403 } from "../models/WebAppGetCompositionsDetailById";

export function getWebAppGetCompositionsDetailByIdUrl(id: WebAppGetCompositionsDetailByIdPathParams["id"]) {
  const res = { method: 'GET', url: `/web-app/v1/compositions/${id}` as const }
  return res
}

/**
 * @summary Get one composition by id
 * {@link /web-app/v1/compositions/:id}
 */
export async function webAppGetCompositionsDetailById(id: WebAppGetCompositionsDetailByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppGetCompositionsDetailByIdQueryResponse, ResponseErrorConfig<WebAppGetCompositionsDetailById401 | WebAppGetCompositionsDetailById403>, unknown>({ method : "GET", url : getWebAppGetCompositionsDetailByIdUrl(id).url.toString(), ... requestConfig })
  return res.data
}